"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));

var _order = require("@/api/order");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ProductPayTemplate',
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      productList: [],
      selectProductId: 0,
      selectPayType: 'wechat',
      dialogWechat: false,
      qrcodeUrl: null,
      timer: null
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created: function created() {
    this.getProductList();
  },
  methods: {
    fomatterPrice: function fomatterPrice(price) {
      return (price / 100).toFixed(2);
    },
    // 获取商品列表
    getProductList: function getProductList() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var productListRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _order.productList)({
                  type: _this.type
                });

              case 2:
                productListRes = _context.sent;
                _this.productList = productListRes.data.data; // this.productList = productList.map(item => {
                //   item.content = JSON.parse(item.content)
                //   return item
                // })

                _this.selectProductId = _this.productList[0].id;
                console.log(_this.productList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 选择商品
    selectProduct: function selectProduct(id) {
      this.selectProductId = id;
    },
    wechatPayClose: function wechatPayClose() {
      this.dialogWechat = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    pay: function pay() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var createOrderRes, createData, submitRes, submitData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this2.dialogWechat) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _this2.dialogWechat = true;

                if (!_this2.qrcodeUrl) {
                  _this2.$nextTick(function () {
                    _this2.qrcodeUrl = new _qrcodejs.default(_this2.$refs['wechat-pay-code'], {
                      text: '',
                      width: 200,
                      height: 200,
                      colorDark: '#000000',
                      colorLight: '#ffffff',
                      correctLevel: _qrcodejs.default.CorrectLevel.H
                    });
                  });
                } else {
                  _this2.qrcodeUrl.clear();
                }

                _context3.next = 6;
                return (0, _order.createOrder)({
                  product_id: _this2.selectProductId
                });

              case 6:
                createOrderRes = _context3.sent;
                createData = createOrderRes.data.data;
                _context3.next = 10;
                return (0, _order.submitOrder)({
                  order_id: createData.order_id
                });

              case 10:
                submitRes = _context3.sent;
                submitData = submitRes.data.data;

                _this2.qrcodeUrl.makeCode(submitData.code_url.substring(submitData.code_url.indexOf('weixin://')));

                _this2.timer = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var payInfo;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return (0, _order.getOrderPayInfo)({
                            order_id: createData.order_id
                          });

                        case 2:
                          payInfo = _context2.sent;

                          if (!(payInfo.data.data.order_status == 4)) {
                            _context2.next = 11;
                            break;
                          }

                          _context2.next = 6;
                          return _this2.$store.dispatch('user/getInfo', {
                            refreshVip: true
                          });

                        case 6:
                          _this2.wechatPayClose();

                          _this2.$message.success('支付成功');

                          clearInterval(_this2.timer);
                          _this2.timer = null;

                          if (_this2.type == 1) {
                            setTimeout(function (_) {
                              _this2.$router.push({
                                path: '/'
                              });
                            }, 1000);
                          }

                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), 1500);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    goBack: function goBack() {
      this.$router.push({
        name: 'Home'
      });
    }
  }
};
exports.default = _default;